import React from 'react';
import Sidebar from './Sidebar';

export default function PurchasePage() {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-white md:px-6 lg:px-10 max-w-7xl">
      <Sidebar />
      <div className="flex-1 p-4 lg:p-8">
        <h1 className="text-3xl md:text-5xl leading-14 font-axi-bold my-5">
          Ostmine
        </h1>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          Üldine
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          Rademari e-poest tellimiseks tuleb valitud tooted lisada ostukorvi.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Tellimuse vormistamiseks avada menüüribal paremas osas paiknev
          ostukorv, seejärel vajutada “Ostukorv”.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Checkout lehel kontrollida valitud toodete suurust, kogust ja hinda
          ning valida sobiva tarne- ja makseviisi.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Vastavalt valitud tarneviisile täita vajalikud väljad.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Kui nõutud andmed on sisestatud, andmete õigsus kontrollitud ja
          kasututingimustega nõustutud, siis tellimuse maksmiseks klikkida
          “Maksma”.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Valida teile sobiv makseviis, pärast makse sooritamist kindlasti
          vajutada nupule “Tagasi kaupmehe juurde”.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          Rademari kliendikaart
        </h2>
        <p className="text-base leading-6 mx-0 my-2">
          Rademari kaupluses vormistatud kliendikaart e-poes ei kehti, kuid
          e-poe kliendiks registreerumine on kiire ja lihtne. Registreerumiseks
          vajutage “LOGI SISSE” nupule, pärast mida on “Loo omale konto” vorm
          leitav “Logi sisse” vormi all.
        </p>
        <p className="text-base leading-6 mx-0 my-2">
          Rademari e-poe registeeritud kliendile kehtib kõikidelt täishinnaga
          toodetelt alati 5% soodustust.
        </p>

        <h2 className="text-2xl md:text-3xl leading-12 font-axi-bold mt-4">
          Makseviisid
        </h2>
        <ul className="list-disc ml-8 mr-0 mt-0 mb-5">
          <li className="text-base leading-6 mx-0 my-2">
            Tellimuse eest saab turvaliselt tasuda krediitkaartidega,
            järelmaksuga või Eesti pangalinkide abil.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Makse toimub väljaspool e-poodi teenusepakkuja Montonio Finance OÜ
            või Inbank AS turvalises maksekeskonnas.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Makseteenuse pakkuja on kohustatud tagama, et kliendi isikuandmed ja
            pangaandmed on kaitstud volitamata juurdepääsu eest.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Müüjal puudub ligipääs kliendi pangaandmetele ja krediitkaardi
            andmetele.
          </li>
          <li className="text-base leading-6 mx-0 my-2">
            Maksmine toimub eurodes.
          </li>
        </ul>
      </div>
    </div>
  );
}

